import { Button, Modal } from 'antd';
import React from 'react';

class ShowInfoPartnerButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      partnerShow: null,
    };

    this.showModal = this.showModal.bind(this);
  }
  componentDidMount() {
    const { partner } = this.props;
    this.setState({
      partnerShow: partner,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.partner !== this.props.partner) {
      this.setState({ partnerShow: this.props.partner });
    }
  }

  showModal() {
    this.setState({
      visible: true,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { visible, partnerShow } = this.state;
    return (
      <>
        {visible && (
          <Modal
            title={`Thông tin về đối tác ${partnerShow.part_name}`}
            visible
            onCancel={this.handleCancel}
            footer={null}
          >
            <p> SĐT: {partnerShow.part_phon} </p>
            <p> SĐT đầu mối liên lạc: {partnerShow.part_ctac_mobi} </p>
            <p> Địa chỉ: {partnerShow.part_addr}</p>
          </Modal>
        )}
        <Button
          onClick={this.showModal}
          size="small"
          className="pull-right"
          style={{ marginLeft: '5px' }}
        >
          <i className="fas fa-info"></i>
        </Button>
      </>
    );
  }
}
export default ShowInfoPartnerButton;
